import {Component, OnInit, Output, EventEmitter, signal} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'projects/store/src/environments/environment';
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpStatusCode} from "@angular/common/http";
import {CustomMessageService, ResponseHttpError, ResponseHttpSuccess} from "library";
import {UtilService} from "library";

@Component({
  selector: 'app-update-product-information',
  templateUrl: './sales-update-product-information.component.html'
})
export class SalesUpdateProductInformationComponent implements OnInit {
  routesBreadcrumbs = ['VENTAS', 'Autogestión', 'Número de serial'];
  serialForm: FormGroup;
  country = environment.global.country;
  requestId: string;
  currentUrl!: string;
  phone!: number;
  minSerialNumberCharacters: number = 1;
  maxSerialNumberCharacters: number = 100;
  @Output() nextStepEvent = new EventEmitter();
  data = signal<any>({});
  readonly categoryCode = this.route.snapshot.params['category_code'];


  constructor(
              private requestService: RequestService,
              private route: ActivatedRoute,
              private customMessageService: CustomMessageService,
              private utilService: UtilService) {

      this.serialForm = this.createFormGroup();
      this.requestId = this.route.snapshot.params['request_id'];
      this.utilService.disablePageLoading();
  }

  ngOnInit(): void {
    this.data.set(this.requestService.request);

  }

  private createFormGroup(): FormGroup {
    return new FormGroup({
      serialNumber: new FormControl(
        null,
        {
          validators: [
            Validators.required,
            Validators.minLength(this.minSerialNumberCharacters),
            Validators.maxLength(this.maxSerialNumberCharacters)
          ],
          updateOn: 'change'
        }
      )
    });
  }

  onSubmit(): void {

    if (this.serialForm.invalid) {
      return;
    }

    const serialNumber = this.serialForm.get('serialNumber')?.value || '';
    const data = { serial: serialNumber };
    this.saveInfoProduct(data);

  }

  saveInfoProduct(data:any) {

    this.requestService.saveInfoProductByRequest(this.requestId, data).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if (resp.status == HttpStatusCode.Created){

          this.onNextStep();

        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
      }
    })
  }

  get f(){
    return this.serialForm.controls;
  }

  onNextStep() {
    this.nextStepEvent.emit();
  }
}
